<div *ngIf="this.task" class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4">
    <div class="w-full h-[90%] max-w-screen-lg flex flex-row gap-1 justify-center overflow-y-auto">
        <div class="w-full h-full flex min-w-full bg-white p-5 rounded-md text-center shadow-lg">
            <div class="w-full h-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-col items-center justify-center p-4 rounded-lg bg-green-50">
                    <div class="w-full flex gap-2 items-center justify-between">                        
                        
                    <h2 class="pb-4 w-full oswald-font text-2xl font-medium text-start text-green-600">
                        Review
                    </h2>
                        <button
                            class="p-1 rounded-full hover:bg-gray-100"
                            (click)="$event.preventDefault(); handleCloseReviewModal();"
                        >
                            <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                        </button>
                    </div>
                    <div class="flex items-center w-full space-x-2 text-center oswald-font text-md">
                        <button class="flex items-center text-start text-green-600">
                            <span class="flex items-center justify-center w-8 h-8 me-2 text-white bg-green-600 rounded-full shrink-0">                                
                                1
                            </span>
                            Behavioral Threat Assessment Screening
                        </button>
                    </div>
                </div>
                <review-assess-screen class="h-full overflow-y-auto" [caseId]="this.task.case_id"></review-assess-screen>
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        class="py-1.5 w-20 rounded-md oswald-font rounded-md bg-white border border-red-700 text-red-700 hover:bg-red-700 hover:text-white"
                        (click)="$event.preventDefault(); this.showRejectionReason = true;"
                    >
                        Reject
                    </button>
                    <button 
                        class="shadow-custom-2 flex items-center justify-center oswald-font text-white h-full w-20 bg-gradient-to-b rounded-md from-green-500 to-green-600 hover:from-green-500 hover:to-green-700"
                        (click)="$event.preventDefault(); approveAssessmentScreen(this.yesNo.Yes);"
                    >
                        Approve
                    </button>
                </div>
                
            </div>
        </div>
    </div>
</div>

<rejection-reason
    *ngIf="this.task && showRejectionReason"
    [caseId]="task.case_id"
    [form_name]="'Behavioral Threat Assessment Screening'"
    (onClose)="this.showRejectionReason = false;"
    (onSubmit)="handleRejectionSubmit($event)">
</rejection-reason>

<div *ngIf="loading">
    <spinner></spinner>
</div>